import { AUTHENTICATION } from '@Constants/types';
import mixpanelEvents from '@Mixpanel';

const { LOGIN_SUCCESS } = AUTHENTICATION;
const { logIn } = mixpanelEvents;

const mixpanelMiddleware = () => next => action => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            const { mixpanelData } = action;
            const {
                system,
                browserLanguage,
                documentId,
                numberOfConfiguredServers,
                authType,
                sealInsightVersion,
                addinVersion
            } = mixpanelData;

            const loginEventProperties = {
                'Login mode': authType,
                'Number of configured servers': numberOfConfiguredServers
            };

            const superProperties = {
                'Seal Connection Id': system,
                'Browser Language': browserLanguage,
                'Document Uid': documentId,
                'Seal Insight Version': sealInsightVersion,
                'DS Analyzer Word add-in version': addinVersion
            };
            logIn(superProperties, loginEventProperties);
            return next(action);

        default:
            return next(action);
    }
};

export default mixpanelMiddleware;
